import { get, post, patch, remove } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  state: {
    app_layouts: []
  },

  getters: {
    RETRIEVED_APP_LAYOUTS: store => {
      return store.app_layouts;
    }
  },

  mutations: {
    retrievedAppLayouts: (state, app_layouts) => {
      state.app_layouts = app_layouts;
    }
  },

  actions: {
    retrieveAppLayouts: () => get('/app-layouts'),

    retrieveAppLayout: (_, appLayout) => get(`/app-layouts/${appLayout}`),

    store: (_, appLayout) => post('/app-layouts', appLayout),

    update: (_, data) => patch(`/app-layouts/${data.app_layout.id}`, data),

    remove: (_, data) => remove(`/app-layouts/${data.app_layout}`)
  }
};
